import { getOrdersByFilter } from 'entities/orders';
import { OrdersTableList } from 'features/orders/ordersTableList';
import { PaginationFilterProvider } from 'shared/ui/pagination';

import { DashboardContainer } from 'widgets/dashboardContainer';
import { OrderDashboard } from 'widgets/orderDashboard';
import { OrderFilterPanel } from 'widgets/orderFilterPanel';

export const Bookings = () => {
	return (
		<PaginationFilterProvider fetchData={getOrdersByFilter}>
			<DashboardContainer>
				<OrderFilterPanel />
				<OrderDashboard
					placeholder="Нажмите на карточку, которая вас интересует, 
						чтобы вы смогли увидеть более полную информацию о бронировании"
					updateOrderInPersonModal={'groupOrders'}
				>
					<OrdersTableList />
				</OrderDashboard>
			</DashboardContainer>
		</PaginationFilterProvider>
	);
};
